import script from "./DetailsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__